export const selectNameOfOpenModal = (state) => state.modalDialogs.name;
